import React, { useEffect, useState } from "react";
import * as moduleActions from "../../action/moduleActions";
import { bindActionCreators } from "redux";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import "./CustomApply.css";

const MainContent = (props) => {
  const { auth, allPatienList } = props;

  const navigate = useHistory();

  useEffect(() => {
    // LoadPatient();
    props.moduleActions.getAllPatientList();
  }, []);

  // const LoadPatient = () => {
  //     axios.get(`${process.env.REACT_APP_API_URL}/GetAllPatient`,{
  //         headers : {
  //             'authorization': AuthStr
  //         }
  //     })
  //         .then(res => {
  //             //console.log("list", res.data)
  //             setPatientList(res.data)
  //         })
  // }

  // const LoadPatient = () => {
  //     axios.get(`${process.env.REACT_APP_API_URL}/GetAllPatient`)
  //         .then(res => {
  //             //console.log("list", res.data)
  //             setPatientList(res.data)
  //         })

  // }

  const ShowIntents = (pid, pName, pGender) => {
    localStorage.setItem("PatQusId", pid);
    localStorage.setItem("PatName", pName);
    // localStorage.setItem('Backvalue', backval)
    localStorage.setItem("PatGender", pGender);

    moduleActions.getIntentsByPid(pid).then((res) => {
      localStorage.setItem("QuestionLength", res.data.length);
      res.data.length > 10
        ? navigate.push("/PtientIntentList")
        : navigate.push("/PtientCusIntentList");
    });
  };

  const EditPatient = (valid) => {
    localStorage.setItem("PatientId", valid);
  };

  return (
    <>
      <div className="page-content-wrapper">
      {allPatienList !== undefined && allPatienList !== null ? (
                
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title">Dashboard</div>
              </div>
              <ol className="breadcrumb page-breadcrumb pull-right">
                <li>
                  <i className="fa fa-home"></i>&nbsp;
                  <a className="parent-item" href="/index">
                    Home
                  </a>
                  &nbsp;<i className="fa fa-angle-right"></i>
                </li>
                <li className="active">Dashboard</li>
              </ol>
            </div>
          </div>

          <div className="state-overview">
            <div className="row dashboard-card-wrapper">
              
            {allPatienList.map((item) => (
                  <div className="col-xl-4 col-md-6 col-12 mb-4">
                    <Link
                      to="/UpdatePatient"
                      onClick={() => EditPatient(item.id)}
                      className=""
                    >
                      <div className="info-box h-100 bg-blue pb-0">
                        <span className="info-box-icon push-bottom">
                          <i className="material-icons">person</i>
                        </span>
                        <div className="info-box-content">
                          <span className="progress-description">
                            {item.patient_Nm}
                          </span>
                          <span
                            className="info-box-text genderfont"
                            style={{ fontSize: "13px" }}
                          >
                            {item.p_Gender}
                          </span>
                          <span className="info-box-number">
                            {item.case_Name}
                          </span>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
                </div>
          </div>
        </div>
              ) : (
                <div className="page-content d-flex justify-content-center align-items-center">
            <div className="my-wrapper">
            <div class="spinner center">
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
              <div class="spinner-blade"></div>
          </div>
            </div>
          
          </div>
              )}
            
      </div>
    </>
  );
};

// export default MainContent;
const mapStateToProps = (state) => {
  //console.log("here state vlue", state)
  return {
    auth: state.auth,
    allPatienList: state.modules.allPatienList,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    moduleActions: bindActionCreators(moduleActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainContent);
